import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthService } from 'src/app/services/auth/auth.service';

@Component({
  selector: 'app-create-profile',
  templateUrl: './create-profile.component.html',
  styleUrls: ['./create-profile.component.css']
})
export class CreateProfileComponent implements OnInit {
  createProfileForm: FormGroup;

  constructor(private authService: AuthService, public formBuilder: FormBuilder) {
    this.createProfileForm = this.formBuilder.group({
      'displayName': [null, Validators.required],
      'currently_studying': [null, Validators.required],
      'want_to_study': [null, Validators.required],
      'when_to_study': [null, Validators.required],
      'phoneNumber': [null, Validators.required],
    })
  }

  ngOnInit(): void {
  }

  create_profile() {
    console.log('working');
    this.authService.createUserProfile(this.createProfileForm.controls.displayName.value,
       this.createProfileForm.controls.currently_studying.value,
        this.createProfileForm.controls.want_to_study.value,
         this.createProfileForm.controls.when_to_study.value,
          this.createProfileForm.controls.phoneNumber.value)
  }
}
